export const MODIFY_CURRENT_PAGE = "MODIFY_CURRENT_PAGE";
export const RESET_APPLICATION = "RESET_APPLICATION";
export const SHOW_NOTIFIED = "SHOW_NOTIFIED";

export const modifyPage = (data) => {
  return {
    type: MODIFY_CURRENT_PAGE,
    data,
  };
};
export const showNotified = (data) => {
  return {
    type: SHOW_NOTIFIED,
    data,
  };
};

export const resetApp = () => {
  return {
    type: RESET_APPLICATION,
    
  };
};
